
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { mapGetters, mapState } from 'vuex';
import { GlobalState } from '@/shared/models/GlobalState';
import { required, email, sameAs } from '@vuelidate/validators';
import { Message } from '@/shared/models/Message';
import FlashMessage from '@/shared/components/FlashMessage.vue';
import { adService } from '../AdService';
import useVuelidate from '@vuelidate/core';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'AdInterestedForm',
  mixins: [Form],
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    FlashMessage,
  },
  props: {
    adFrontId: String,
    price: Number,
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      privacyUrl: config.PRIVACY_URL,
      messageWasChangedByUser: false,
      messages: [] as Message[],
      form: {
        adFrontId: this.adFrontId,
        email: null as string | null,
        phone: null as string | null,
        subject: null as string | null,
        message: null as string | null,
        personalAgreement: !config.IS_ESTATE_AGENCY_MODE,
      },
      subjects: [] as any[],
    };
  },
  validations() {
    return {
      form: {
        email: { required, email },
        phone: {},
        subject: { required },
        message: {},
        personalAgreement: { sameAs: sameAs(true) },
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => (state as GlobalState).user,
    }),
    ...mapGetters(['isLoggedIn']),
  },
  created() {
    if (this.user) {
      this.form.email = this.user.email;
      this.form.phone = this.user.phoneNumber;
    }
    this.subjects.push({ title: this.$t('AdInterestedForm.subject_option_1_title'), message: this.$t('AdInterestedForm.subject_option_1_message') });
    this.subjects.push({ title: this.$t('AdInterestedForm.subject_option_2_title'), message: this.$t('AdInterestedForm.subject_option_2_message') });
    this.subjects.push({ title: this.$t('AdInterestedForm.subject_option_3_title'), message: this.$t('AdInterestedForm.subject_option_3_message') });
    if (!this.price)
      this.subjects.push({ title: this.$t('AdInterestedForm.subject_option_4_title'), message: this.$t('AdInterestedForm.subject_option_4_message') });
    this.form.subject = this.subjects[0].title;
    this.form.message = this.subjects[0].message;
  },
  methods: {
    async send() {
      if (!this.validate()) return;

      try {
        const result = await adService.interested(this.form);
        this.messages.push(result.data);
        this.success();
      } catch (error) {
        this.handleApiError(error);
      }
    },
    onMessageChange() {
      this.messageWasChangedByUser = true;
    },
    onSubjectChange() {
      const item = this.subjects.find((x) => x.title === this.form.subject);
      if (item && !this.messageWasChangedByUser) {
        this.form.message = item.message;
      }
    },
  },
});
